// REMINDER: DO NOT HARDCODE ANY RETURN/REDIRECT DOMAIN OTHER THAN THE ONE REGISTERED
// WITH APPLE, AND DO NOT ADD FALLBACK REDIRECT URLS — THIS BREAKS THE AUTH.
// Shared Sign in with Apple entry point (WEB) — the ONLY place that builds the
// authorization redirect. /login (LoginPage.js), /signup (SignupPage.js) and the
// Dashboard guest conversion modal all use this same flow. Hermano de googleAuth.js.
const APPLE_AUTH_URL = 'https://appleid.apple.com/auth/authorize';
// Services ID de Apple. Público por diseño (viaja en la URL de autorización), igual
// que el client_id de Google de al lado. Hardcodeado por el mismo criterio: el flujo
// nunca depende de una env var de build. Su espejo en el backend es
// config.APPLE_WEB_CLIENT_ID, y es contra ESE valor que se valida el `aud` del token.
const APPLE_CLIENT_ID = 'vc.studybuddy.web';
// SIEMPRE la URL de producción, incluso corriendo en localhost: Apple solo acepta
// redirect URIs registradas en su portal, y `http://localhost:3000/...` no lo es (ni
// puede serlo: Apple exige https). El regreso a localhost lo resuelve el trampolín del
// backend, que lee el origen desde el `state` y rebota ahí.
const APPLE_RETURN_URL = 'https://studybuddy-api-virginia.onrender.com/api/auth/apple/web-return';

function randomHex(bytes) {
  const buf = new Uint8Array(bytes);
  window.crypto.getRandomValues(buf);
  return Array.from(buf, (b) => b.toString(16).padStart(2, '0')).join('');
}

function base64url(value) {
  return window.btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function redirectToAppleLogin() {
  // El `state` carga DOS trabajos en un solo parámetro:
  //   <random>  — el anti-CSRF de siempre (la página de retorno lo compara contra
  //               sessionStorage y aborta sin llamar al backend si no cuadra);
  //   <origin>  — a dónde tiene que rebotar el trampolín, en base64url. Va aquí y no
  //               en un parámetro suelto porque Apple devuelve el `state` intacto y
  //               firmado dentro de su propio flujo, mientras que un parámetro extra
  //               sería un destino que cualquiera podría inyectar. Aun así el backend
  //               lo valida contra una whitelist cerrada: esto es comodidad, no la
  //               garantía.
  const state = `${randomHex(32)}.${base64url(window.location.origin)}`;
  // El `nonce` ata el id_token a ESTA pestaña: viaja a Apple, vuelve dentro del token
  // firmado, y el backend exige que coincida con el que la página de retorno le manda.
  const nonce = randomHex(32);
  sessionStorage.setItem('apple_oauth_state', state);
  sessionStorage.setItem('apple_oauth_nonce', nonce);
  const params = new URLSearchParams({
    client_id: APPLE_CLIENT_ID,
    redirect_uri: APPLE_RETURN_URL,
    response_type: 'code id_token',
    scope: 'name email',
    // Obligatorio de Apple en cuanto se pide `scope=email`: el retorno es un POST.
    // Ésta es la única divergencia real contra el flujo de Google, y es la razón de
    // que exista el trampolín del backend (un POST contra Cloudflare Pages da 405).
    response_mode: 'form_post',
    state,
    nonce,
  });
  window.location.href = `${APPLE_AUTH_URL}?${params.toString()}`;
}
